import PropTypes from "prop-types";
import { Button, Tooltip } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";

export default function PrintButton({ isLoading = false, height = 40, tooltipTitle = "Tulosta" }) {
  const handleKlik = () => window.print();

  return (
    <div className="noPrint">
      <Tooltip title={tooltipTitle} placement="top" disableInteractive>
        <span>
          <Button
            variant="outlined"
            onClick={handleKlik}
            disabled={isLoading}
            sx={{ height: height }}
            aria-label="Tulosta">
            <PrintIcon color="primary" />
          </Button>
        </span>
      </Tooltip>
    </div>
  );
}

PrintButton.propTypes = {
  isLoading: PropTypes.bool,
  height: PropTypes.number,
  tooltipTitle: PropTypes.string,
};
